import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    fullSized: {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.3)',
        height: '100%',
        width: '100%',
        zIndex: 4,
    },
    onAutoComplete: {
        position: 'relative',
        float: 'unset',
        width: '70px',
        height: '38px',
        zIndex: 1,
        background: '#FFF',
        objectFit: 'cover',
        marginRight: -30,
        "& .loader": {
            width: '40px',
            height: '40px',
            float: 'right',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            top: 'unset',
            bottom: 'unset',
            left: 'unset',
            right: 'unset',
            margin: 'unset',
            "& div": {
                top: 'unset',
                left: 'unset',
            }
        }
    },
    normal: {
        position: 'relative',
    },
    borderColor: {
        '& .circle-1, .circle-2, .circle-3': {
            borderColor: `${theme.palette.primary.main} !important`
        }
    },
    titulo: {
        // marginTop: theme.spacing(4),
        fontWeight: 500,
        color: theme.palette.primary.main,
        lineHeight: 1.2,
        // position: 'absolute',
        // bottom: 20,
    },
    loaderCircle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column-reverse',
        textAlign: 'center',
        width: '100%',
        minHeight: '150px'
    }
}));

